import { ROLES } from "utils/helpers/enums/roles.enum";
import { AGE_GROUPS } from "utils/helpers/enums/shared.enum";

export class FilterDTO {
    page: number = 0;
    size: number = 12;
    totalPages: number = 0;
    totalElements: number = 0;
    role: ROLES;
    search: string = '';
    sortBy: string = 'createdAt';
    sortDir: string = 'asc'
    tag: string = '';
    badgeType?: string = '';
    

    // constructor(data: Partial<FilterDTO> = {}) {
    //     for (let key in data) {
    //         if (key in this) {
    //             if (key === 'role' || key === 'search') {
    //                 this[key] = data[key] as any;
    //             } else {
    //                 this[key] = +data[key];
    //             }
    //         }
    //     }
    // }
    constructor(data: Partial<FilterDTO> = {}) {
    for (let key in data) {
      if (key in this) {
        const value = data[key];
        if (['page', 'size', 'totalPages', 'totalElements'].includes(key)) {
          this[key] = +value; // ✅ convert only numeric fields
        } else {
          this[key] = value as any; // ✅ leave string & enum fields as-is
        }
      }
    }
  }
}